import i18n from '../../i18n';
// networth sections
export const sections = {
    creditCards: 'Credit Cards',
    savings: 'Savings',
    investments: 'Investments',
    loans: 'Loans',
    mortgages: 'Mortgages',
    realEstate: 'Real Estate',
    vehicles: 'Vehicles',
    otherAssets: 'Other assets',
    assets: 'Assets',
    debt: 'Debt',
    netWorth: 'Net worth',
    pensions: 'Pensions',
    hidden: 'Hidden',
    closed: 'Closed',
};
export const PHYSICAL_ASSET_TYPES = new Set([
    'REAL_ESTATE',
    'VEHICLE',
    'OTHER',
]);
export const DUMMY_ACCOUNT_TEXT_MAP = {
    CHECKING: `${i18n.t('current')} account`,
    CREDITCARD: 'Credit card',
    SAVINGS: 'Savings account',
    LOAN: 'Loan',
    MORTGAGE: 'Mortgage',
    INVESTMENT: 'Investment account',
    PENSION: 'Pension',
    REAL_ESTATE: 'Real estate',
    VEHICLE: 'Vehicle',
    OTHER: 'Other assets',
};
export const overviewColorMap = {
    Everyday: 'income',
    Savings: 'feed',
    Investments: 'investment',
    'Net worth': 'brand',
    Debt: 'debt',
    Cash: 'income',
    Checking: 'income',
    Current: 'income',
    Pensions: 'positive',
};
export const getPropertyName = (type) => {
    if (type === 'REAL_ESTATE') {
        return 'Property';
    }
    if (type === 'VEHICLE') {
        return 'Vehicle';
    }
    return 'Asset';
};
